// SEQ=10113 P8-CK-B — KnightPanel: 본인 기사 목록 + 5종 액션 버튼
// EXT_CK ON 룸 전용. CatanGame.isExtCk가 false면 부모가 렌더하지 않음.
import { CatanKnight } from '../store/catan'

interface Props {
  myKnights:          CatanKnight[]
  isMyTurn:           boolean
  myWool:             number          // WOOL 보유 수
  myOre:              number          // ORE 보유 수
  myWheat:            number          // WHEAT 보유 수
  /** Build Knight 버튼 클릭 → 부모가 vertex 선택 모드로 전환 */
  onBuildKnightClick: () => void
  onUpgradeClick:     (knightId: number) => void
  onActivateClick:    (knightId: number) => void
  /** 이동/도적 추방은 Active 기사 한정. 부모가 클릭 후 대상 vertex/hex 선택 모드로 전환 */
  onMoveClick:        (knightId: number) => void
  onChaseRobberClick: (knightId: number) => void
}

const LEVEL_LABEL: Record<number, { ko: string; en: string; emoji: string }> = {
  1: { ko: '기본', en: 'Basic',  emoji: '🛡️' },
  2: { ko: '강한', en: 'Strong', emoji: '⚔️' },
  3: { ko: '강력', en: 'Mighty', emoji: '🔱' },
}

export default function KnightPanel({
  myKnights, isMyTurn, myWool, myOre, myWheat,
  onBuildKnightClick, onUpgradeClick, onActivateClick,
  onMoveClick, onChaseRobberClick,
}: Props) {
  const canBuild    = isMyTurn && myWool >= 1 && myOre >= 1
  const canUpgrade  = (lv: number) => isMyTurn && lv < 3 && myWool >= 1 && myOre >= 1
  const canActivate = (active: boolean) => isMyTurn && !active && myWheat >= 1

  return (
    <div className="knight-panel" style={{ border: '1px solid #888', padding: 8, marginTop: 8 }}>
      <h4 style={{ margin: '0 0 6px 0' }}>기사 (Knight)</h4>
      <div style={{ marginBottom: 6 }}>
        <button onClick={onBuildKnightClick} disabled={!canBuild} title="Basic Knight 건설 (WOOL 1 + ORE 1)">
          🛡️ 기사 건설 (WOOL 1 + ORE 1)
        </button>
      </div>
      {myKnights.length === 0 ? (
        <div style={{ color: '#999', fontSize: 12 }}>보유 기사 없음</div>
      ) : (
        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
          {myKnights.map(k => {
            const lbl = LEVEL_LABEL[k.level] ?? LEVEL_LABEL[1]
            return (
              <li key={k.knightId} style={{
                padding: '4px 0',
                borderBottom: '1px dashed #ccc',
                opacity: k.isActive ? 1 : 0.7,
              }}>
                <span style={{ fontWeight: k.isActive ? 'bold' : 'normal' }}>
                  {lbl.emoji} {lbl.ko} (LV{k.level}) @ vertex {k.vertexId}
                </span>
                <span style={{ marginLeft: 6, fontSize: 12, color: k.isActive ? '#2e7d32' : '#888' }}>
                  {k.isActive ? '[활성]' : '[비활성]'}
                </span>
                <span style={{ marginLeft: 6 }}>
                  <button
                    onClick={() => onUpgradeClick(k.knightId)}
                    disabled={!canUpgrade(k.level)}
                    title="격상 (WOOL 1 + ORE 1)"
                  >격상</button>
                  <button
                    onClick={() => onActivateClick(k.knightId)}
                    disabled={!canActivate(k.isActive)}
                    title="활성화 (WHEAT 1)"
                    style={{ marginLeft: 4 }}
                  >활성</button>
                  <button
                    onClick={() => onMoveClick(k.knightId)}
                    disabled={!isMyTurn || !k.isActive}
                    title="이동 (활성 기사만, 도로 1칸)"
                    style={{ marginLeft: 4 }}
                  >이동</button>
                  <button
                    onClick={() => onChaseRobberClick(k.knightId)}
                    disabled={!isMyTurn || !k.isActive}
                    title="도적 추방 (활성 기사 + 도적 인접 vertex)"
                    style={{ marginLeft: 4 }}
                  >도적</button>
                </span>
              </li>
            )
          })}
        </ul>
      )}
    </div>
  )
}
